module.exports = __webpack_public_path__ + "img/DB4-1920_11.d90a38f1.jpg";